// This file is auto-generated by @hey-api/openapi-ts

import { type Options, urlSearchParamsBodySerializer, formDataBodySerializer } from '@hey-api/client-fetch';
import type { StartOrganizationUserMgtAddPublicKeyStartPostData, StartOrganizationUserMgtAddPublicKeyStartPostResponse, StartOrganizationUserMgtAddPublicKeyStartPostError, StartOrganizationUserMgtGetPublicKeysStartPostData, StartOrganizationUserMgtGetPublicKeysStartPostResponse, StartOrganizationOrganizationMgtGetOrganizationsStartPostData, StartOrganizationOrganizationMgtGetOrganizationsStartPostResponse, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponse, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostError, StartBizArtefactManagementAddArtefactGroupStartPostData, StartBizArtefactManagementAddArtefactGroupStartPostError, StartBizArtefactManagementRemoveArtefactGroupStartPostData, StartBizArtefactManagementRemoveArtefactGroupStartPostError, StartBizArtefactManagementUpdateArtefactStartPostData, StartBizArtefactManagementUpdateArtefactStartPostError, StartBizArtefactManagementAddArtefactStartPostData, StartBizArtefactManagementAddArtefactStartPostResponse, StartBizArtefactManagementAddArtefactStartPostError, StartBizArtefactManagementGetArtefactsTreeStartPostData, StartBizArtefactManagementGetArtefactsTreeStartPostResponse, StartBizArtefactManagementGetArtefactsTreeStartPostError, StartBizArtefactManagementRemoveArtefactStartPostData, StartBizArtefactManagementRemoveArtefactStartPostError, StartBizArtefactManagementGetHistoryStartPostData, StartBizArtefactManagementGetHistoryStartPostResponse, StartBizArtefactManagementGetHistoryStartPostError, StartBizArtefactManagementRenameArtefactGroupStartPostData, StartBizArtefactManagementRenameArtefactGroupStartPostError, StartBizArtefactManagementGetArtefactStartPostData, StartBizArtefactManagementGetArtefactStartPostError, StartBizArtefactManagementRestoreHistoricalArtefactStartPostData, StartBizArtefactManagementRestoreHistoricalArtefactStartPostError, StartBizArtefactManagementRenameArtefactStartPostData, StartBizArtefactManagementRenameArtefactStartPostError, StartBizArtefactManagementUpdateArtefactContentStartPostData, StartBizArtefactManagementUpdateArtefactContentStartPostError, StartBizEntitiesEntityTypeEntityIdInfoGetData, StartBizEntitiesEntityTypeEntityIdInfoGetResponse, StartBizEntitiesEntityTypeEntityIdInfoGetError, StartBizEntitiesEntityTypeEntityIdAttributeGetData, StartBizEntitiesEntityTypeEntityIdAttributeGetError, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponse, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetError, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostError, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponse, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostError, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostData, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponse, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostError, StartWorkspaceWorktreeMgtGetWorktreeStartPostData, StartWorkspaceWorktreeMgtGetWorktreeStartPostResponse, StartWorkspaceWorktreeMgtGetWorktreeStartPostError, StartStekStekMgtTreeStartPostData, StartStekStekMgtTreeStartPostError, StartStekStekMgtGetSteksByOrganizationStartPostData, StartStekStekMgtGetSteksByOrganizationStartPostResponse, StartStekStekMgtCreateStekStartPostData, StartStekStekMgtCreateStekStartPostError, StartStekStekMgtUpdateStekStartPostData, StartStekStekMgtUpdateStekStartPostError, StartStekStekMgtGetStekStartPostData, StartStekStekMgtGetStekStartPostResponse, StartStekStekMgtDeleteStekStartPostData, StartAgentMcpManifestStartPostData, StartAgentMcpManifestStartPostResponse, StartAgentMcpGetResourceStartPostData, StartAgentMcpGetResourceStartPostResponse, StartAgentMcpGetResourceStartPostError, StartAgentDocPromptStartPostData, StartAgentDocPromptStartPostError, StartProductProductMgtGetProductStartPostData, StartProductProductMgtGetProductStartPostResponse, StartProductProductMgtGetProductStartPostError, StartProductProductMgtUpdateProductStartPostData, StartProductProductMgtUpdateProductStartPostError, StartProductProductMgtDeleteProductStartPostData, StartProductProductMgtDeleteProductStartPostError, StartProductProductMgtCreateProductStartPostData, StartProductProductMgtCreateProductStartPostResponse, StartProductProductMgtCreateProductStartPostError, StartProductProductMgtGetProductsByDomainStartPostData, StartProductProductMgtGetProductsByDomainStartPostResponse, StartProductProductMgtGetProductsByDomainStartPostError, StartDashboardDashboardMgtGetDashboardsByStekStartPostData, StartDashboardDashboardMgtGetDashboardsByStekStartPostResponse, StartDashboardDashboardMgtUpdateDashboardStartPostData, StartDashboardDashboardMgtUpdateDashboardStartPostResponse, StartDashboardDashboardMgtUpdateDashboardStartPostError, StartDomainDomainMgtDeleteDomainStartPostData, StartDomainDomainMgtDeleteDomainStartPostError, StartDomainDomainMgtGetDomainsByStekStartPostData, StartDomainDomainMgtGetDomainsByStekStartPostResponse, StartDomainDomainMgtUpdateDomainStartPostData, StartDomainDomainMgtUpdateDomainStartPostError, StartDomainDomainMgtGetDomainStartPostData, StartDomainDomainMgtGetDomainStartPostResponse, StartDomainDomainMgtGetDomainStartPostError, StartDomainDomainMgtCreateDomainStartPostData, StartDomainDomainMgtCreateDomainStartPostResponse, StartDomainDomainMgtCreateDomainStartPostError, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostError, StartDomainBusinessEntityMgtGetBusinessEntityStartPostData, StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponse, StartDomainBusinessEntityMgtGetBusinessEntityStartPostError, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostError, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostError, StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostData, StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponse, StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostError, StartDomainRoleMgtGetRolesStartPostData, StartDomainRoleMgtGetRolesStartPostResponse, StartDomainRoleMgtGetRolesStartPostError, StartDomainRoleMgtCreateRoleStartPostData, StartDomainRoleMgtCreateRoleStartPostError, StartDomainRoleMgtUpdateRoleStartPostData, StartDomainRoleMgtUpdateRoleStartPostError, StartDomainRoleMgtDeleteRoleStartPostData, StartDomainRoleMgtDeleteRoleStartPostError, StartDomainRoleMgtGetRoleStartPostData, StartDomainRoleMgtGetRoleStartPostResponse, StartDomainRoleMgtGetRoleStartPostError, StartProcessLaneMgtGetLaneStartPostData, StartProcessLaneMgtGetLaneStartPostResponse, StartProcessLaneMgtGetLaneStartPostError, StartProcessLaneMgtGetLaneByRoleIdStartPostData, StartProcessLaneMgtGetLaneByRoleIdStartPostResponse, StartProcessLaneMgtGetLaneByRoleIdStartPostError, StartProcessLaneMgtGetLaneByBpmnIdStartPostData, StartProcessLaneMgtGetLaneByBpmnIdStartPostResponse, StartProcessLaneMgtGetLaneByBpmnIdStartPostError, StartProcessLaneMgtGetLanesByProcessStartPostData, StartProcessLaneMgtGetLanesByProcessStartPostResponse, StartProcessLaneMgtGetLanesByProcessStartPostError, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponse, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostError, StartProcessProcessElementMgtDeleteGatewayStartPostData, StartProcessProcessElementMgtDeleteGatewayStartPostError, StartProcessProcessElementMgtUpdateEventStartPostData, StartProcessProcessElementMgtUpdateEventStartPostError, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponse, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostError, StartProcessProcessElementMgtGenerateUserInterfaceStartPostData, StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponse, StartProcessProcessElementMgtGenerateUserInterfaceStartPostError, StartProcessProcessElementMgtUpdateGatewayStartPostData, StartProcessProcessElementMgtUpdateGatewayStartPostError, StartProcessProcessElementMgtGetEventStartPostData, StartProcessProcessElementMgtGetEventStartPostResponse, StartProcessProcessElementMgtGetEventStartPostError, StartProcessProcessElementMgtUnarchiveProcessElementStartPostData, StartProcessProcessElementMgtUnarchiveProcessElementStartPostError, StartProcessProcessElementMgtDeleteEventStartPostData, StartProcessProcessElementMgtDeleteEventStartPostError, StartProcessProcessElementMgtArchiveProcessElementStartPostData, StartProcessProcessElementMgtArchiveProcessElementStartPostError, StartProcessProcessElementMgtDeleteTaskStartPostData, StartProcessProcessElementMgtDeleteTaskStartPostError, StartProcessProcessElementMgtGetTaskStartPostData, StartProcessProcessElementMgtGetTaskStartPostResponse, StartProcessProcessElementMgtGetTaskStartPostError, StartProcessProcessElementMgtUpdateFlowStartPostData, StartProcessProcessElementMgtUpdateFlowStartPostError, StartProcessProcessElementMgtGetGatewayStartPostData, StartProcessProcessElementMgtGetGatewayStartPostResponse, StartProcessProcessElementMgtGetGatewayStartPostError, StartProcessProcessElementMgtUpdateTaskStartPostData, StartProcessProcessElementMgtUpdateTaskStartPostError, StartProcessProcessElementMgtGetFlowStartPostData, StartProcessProcessElementMgtGetFlowStartPostResponse, StartProcessProcessElementMgtGetFlowStartPostError, StartProcessProcessElementMgtDeleteFlowStartPostData, StartProcessProcessElementMgtDeleteFlowStartPostError, StartProcessProcessMgtGetProcessStartPostData, StartProcessProcessMgtGetProcessStartPostResponse, StartProcessProcessMgtGetProcessStartPostError, StartProcessProcessMgtMoveProcessStartPostData, StartProcessProcessMgtMoveProcessStartPostError, StartProcessProcessMgtGenerateDefinitionStartPostData, StartProcessProcessMgtGenerateDefinitionStartPostResponse, StartProcessProcessMgtGenerateDefinitionStartPostError, StartProcessProcessMgtDeployProcessStartPostData, StartProcessProcessMgtDeployProcessStartPostResponse, StartProcessProcessMgtDeployProcessStartPostError, StartProcessProcessMgtUpdateProcessStartPostData, StartProcessProcessMgtUpdateProcessStartPostError, StartProcessProcessMgtDeleteProcessStartPostData, StartProcessProcessMgtDeleteProcessStartPostError, StartProcessProcessMgtCreateProcessStartPostData, StartProcessProcessMgtCreateProcessStartPostResponse, StartProcessProcessMgtCreateProcessStartPostError, StartProcessProcessMgtGetProcessesByProductStartPostData, StartProcessProcessMgtGetProcessesByProductStartPostResponse, StartProcessProcessMgtGetProcessesByProductStartPostError, GetUsersUserGetData, GetUsersUserGetResponse, CreateUserUserPostData, CreateUserUserPostResponse, CreateUserUserPostError, SignupUserSignupPostData, SignupUserSignupPostResponse, SignupUserSignupPostError, DeleteUserUserUserIdDeleteData, DeleteUserUserUserIdDeleteError, GetSelfUserMeGetData, GetSelfUserMeGetResponse, GetDomainRolesUserUserIdDomainRolesGetData, GetDomainRolesUserUserIdDomainRolesGetResponse, GetDomainRolesUserUserIdDomainRolesGetError, MakeUserManagerUserUserIdMakeUserManagerPostData, MakeUserManagerUserUserIdMakeUserManagerPostError, MakeUserUserUserIdMakeUserPostData, MakeUserUserUserIdMakeUserPostError, ListApiKeysUserApiKeysGetData, ListApiKeysUserApiKeysGetResponse, CreateApiKeyUserApiKeyPostData, CreateApiKeyUserApiKeyPostResponse, CreateApiKeyUserApiKeyPostError, RevokeApiKeyUserApiKeyApiKeyIdDeleteData, RevokeApiKeyUserApiKeyApiKeyIdDeleteResponse, RevokeApiKeyUserApiKeyApiKeyIdDeleteError, PreviewLinkProxyPreviewLinkGetData, PreviewLinkProxyPreviewLinkGetResponse, PreviewLinkProxyPreviewLinkGetError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

/**
 * Start
 * Add a public key for a User.
 */
export const startOrganizationUserMgtAddPublicKeyStartPost = <ThrowOnError extends boolean = false>(options: Options<StartOrganizationUserMgtAddPublicKeyStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartOrganizationUserMgtAddPublicKeyStartPostResponse, StartOrganizationUserMgtAddPublicKeyStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/organization/user_mgt/add_public_key/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get public keys for user.
 */
export const startOrganizationUserMgtGetPublicKeysStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartOrganizationUserMgtGetPublicKeysStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartOrganizationUserMgtGetPublicKeysStartPostResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/organization/user_mgt/get_public_keys/start',
        ...options
    });
};

/**
 * Start
 * Get a list of organizations that current logged-in user has access to.
 */
export const startOrganizationOrganizationMgtGetOrganizationsStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartOrganizationOrganizationMgtGetOrganizationsStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartOrganizationOrganizationMgtGetOrganizationsStartPostResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/organization/organization_mgt/get_organizations/start',
        ...options
    });
};

/**
 * Start
 * Get Domain
 */
export const startOrganizationOrganizationMgtGetOrganizationByNameStartPost = <ThrowOnError extends boolean = false>(options: Options<StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponse, StartOrganizationOrganizationMgtGetOrganizationByNameStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/organization/organization_mgt/get_organization_by_name/start',
        ...options
    });
};

/**
 * Start
 * Add artefact group to an entity
 *
 * Request params (multipart/form-data):
 * owner_id: str - The ID of the owner of the artefact
 * name: str - The name of the artefact group
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementAddArtefactGroupStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementAddArtefactGroupStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizArtefactManagementAddArtefactGroupStartPostError, ThrowOnError>({
        ...urlSearchParamsBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/add_artefact_group/start',
        ...options,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Remove an Artefact group.
 *
 * Request params:
 * - artefact_group_id: str - The identity of the Artefact group to remove
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRemoveArtefactGroupStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRemoveArtefactGroupStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizArtefactManagementRemoveArtefactGroupStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/remove_artefact_group/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update an Artefact. Any parameters given will be updated.
 *
 * Request params (multipart/form-data):
 * artefact_id: str - The ID of the artefact to update.
 * content: File - The file contents to update.
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}".
 * user_email: str - The email of the user making the request.
 */
export const startBizArtefactManagementUpdateArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementUpdateArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizArtefactManagementUpdateArtefactStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/update_artefact/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Add an artefact to an entity.
 *
 * Request params (multipart/form-data):
 * owner_id: str - The ID of the owner of the artefact
 * file_: file - The file to add as an artefact
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementAddArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementAddArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartBizArtefactManagementAddArtefactStartPostResponse, StartBizArtefactManagementAddArtefactStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/add_artefact/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get artefact tree for given Entity containing directories and files
 */
export const startBizArtefactManagementGetArtefactsTreeStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementGetArtefactsTreeStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartBizArtefactManagementGetArtefactsTreeStartPostResponse, StartBizArtefactManagementGetArtefactsTreeStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/get_artefacts_tree/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Remove an Artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to remove
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRemoveArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRemoveArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizArtefactManagementRemoveArtefactStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/remove_artefact/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get the history of a given artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to get the history of
 * - limit?: int - The maximum number of history items to return, defaults to 10
 * - offset?: int - The number of history items to skip, defaults to 0
 */
export const startBizArtefactManagementGetHistoryStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementGetHistoryStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartBizArtefactManagementGetHistoryStartPostResponse, StartBizArtefactManagementGetHistoryStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/get_history/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Rename an Artefact Group.
 *
 * Request params:
 * - artefact_group_id: str - The identity of the Artefact Group to rename
 * - name: str - The new name of the Artefact Group
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRenameArtefactGroupStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRenameArtefactGroupStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizArtefactManagementRenameArtefactGroupStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/rename_artefact_group/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get the artefact in the given location
 *
 * Request params:
 * - artefact_id: str - The identity of the artefact to get
 * - revision: str - Optional revision of the artefact to get
 */
export const startBizArtefactManagementGetArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementGetArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizArtefactManagementGetArtefactStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/get_artefact/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Restore an Artefact from the history.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to remove
 * - revision?: str - The revision to restore the artefact from
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRestoreHistoricalArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRestoreHistoricalArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizArtefactManagementRestoreHistoricalArtefactStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/restore_historical_artefact/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * @deprecated
 * Start
 * Rename an Artefact.
 *
 * Request params:
 * - artefact_id: str - The identity of the Artefact to rename
 * - name: str - The new name of the Artefact
 * - commit_message?: str - A message to add to the commit
 * - user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementRenameArtefactStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementRenameArtefactStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizArtefactManagementRenameArtefactStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/rename_artefact/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * @deprecated
 * Start
 * Add a file artefact to an entity
 * Request params (multipart/form-data):
 * artefact_id: str - The ID of the artefact to update
 * file_: file - The file to add as an artefact
 * commit_message?: str - A message to add to the commit, defaults to "Updated {filepath}"
 * user_email: str - The email of the user making the request
 */
export const startBizArtefactManagementUpdateArtefactContentStartPost = <ThrowOnError extends boolean = false>(options: Options<StartBizArtefactManagementUpdateArtefactContentStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizArtefactManagementUpdateArtefactContentStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/artefact_management/update_artefact_content/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get entity info
 */
export const startBizEntitiesEntityTypeEntityIdInfoGet = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdInfoGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StartBizEntitiesEntityTypeEntityIdInfoGetResponse, StartBizEntitiesEntityTypeEntityIdInfoGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/entities/{entity_type}/{entity_id}/info',
        ...options
    });
};

/**
 * Start
 * Get the entity in the given location using pre-signed URL
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 */
export const startBizEntitiesEntityTypeEntityIdAttributeGet = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdAttributeGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, StartBizEntitiesEntityTypeEntityIdAttributeGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/entities/{entity_type}/{entity_id}/{attribute}',
        ...options
    });
};

/**
 * Start
 * Get the entity history using pre-signed URL
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 * - limit: int - The number of history items to return
 * - offset: int - The number of history items to skip
 */
export const startBizEntitiesEntityTypeEntityIdAttributeHistoryGet = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponse, StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/history',
        ...options
    });
};

/**
 * Start
 * Restore an entity to a previous version.
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 * - attribute: str - The attribute to get
 * - revision: str - The revision to restore
 */
export const startBizEntitiesEntityTypeEntityIdAttributeRestorePost = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartBizEntitiesEntityTypeEntityIdAttributeRestorePostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/restore',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Generate an entity description
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 */
export const startBizEntitiesEntityTypeEntityIdGenerateDescriptionPost = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponse, StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/entities/{entity_type}/{entity_id}/generate_description',
        ...options
    });
};

/**
 * Start
 * Generate an entity children based on the context available.
 *
 * Request params:
 * - entity_type: str - The type of the entity
 * - entity_id: str - The identity of the entity
 */
export const startBizEntitiesEntityTypeEntityIdGenerateChildrenPost = <ThrowOnError extends boolean = false>(options: Options<StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponse, StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/biz/entities/{entity_type}/{entity_id}/generate_children',
        ...options
    });
};

/**
 * Start
 * Get Workspace by Stek
 */
export const startWorkspaceWorktreeMgtGetWorktreeStartPost = <ThrowOnError extends boolean = false>(options: Options<StartWorkspaceWorktreeMgtGetWorktreeStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartWorkspaceWorktreeMgtGetWorktreeStartPostResponse, StartWorkspaceWorktreeMgtGetWorktreeStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/workspace/worktree_mgt/get_worktree/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get tree for given Stek containing all directories and files
 */
export const startStekStekMgtTreeStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtTreeStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartStekStekMgtTreeStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/stek/stek_mgt/tree/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Steks by Organization
 */
export const startStekStekMgtGetSteksByOrganizationStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtGetSteksByOrganizationStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartStekStekMgtGetSteksByOrganizationStartPostResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/stek/stek_mgt/get_steks_by_organization/start',
        ...options
    });
};

/**
 * Start
 * Create a new Stek with optional logo and FQDN
 */
export const startStekStekMgtCreateStekStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekMgtCreateStekStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartStekStekMgtCreateStekStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/stek/stek_mgt/create_stek/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update a Stek's attributes including name, FQDN, and logo.
 */
export const startStekStekMgtUpdateStekStartPost = <ThrowOnError extends boolean = false>(options: Options<StartStekStekMgtUpdateStekStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartStekStekMgtUpdateStekStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/stek/stek_mgt/update_stek/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Stek
 */
export const startStekStekMgtGetStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtGetStekStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartStekStekMgtGetStekStartPostResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/stek/stek_mgt/get_stek/start',
        ...options
    });
};

/**
 * Start
 * Delete a STek
 */
export const startStekStekMgtDeleteStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartStekStekMgtDeleteStekStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/stek/stek_mgt/delete_stek/start',
        ...options
    });
};

/**
 * Start
 * Get MCP manifest with resource URIs.
 */
export const startAgentMcpManifestStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartAgentMcpManifestStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartAgentMcpManifestStartPostResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/agent/mcp/manifest/start',
        ...options
    });
};

/**
 * Start
 * Resource endpoint to read MCP resources.
 */
export const startAgentMcpGetResourceStartPost = <ThrowOnError extends boolean = false>(options: Options<StartAgentMcpGetResourceStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartAgentMcpGetResourceStartPostResponse, StartAgentMcpGetResourceStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/agent/mcp/get_resource/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get response from doc
 */
export const startAgentDocPromptStartPost = <ThrowOnError extends boolean = false>(options: Options<StartAgentDocPromptStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartAgentDocPromptStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/agent/doc/prompt/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Product
 */
export const startProductProductMgtGetProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtGetProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProductProductMgtGetProductStartPostResponse, StartProductProductMgtGetProductStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/product/product_mgt/get_product/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update a Product
 */
export const startProductProductMgtUpdateProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtUpdateProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProductProductMgtUpdateProductStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/product/product_mgt/update_product/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Delete a Product
 */
export const startProductProductMgtDeleteProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtDeleteProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProductProductMgtDeleteProductStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/product/product_mgt/delete_product/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Create a new Product
 */
export const startProductProductMgtCreateProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtCreateProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProductProductMgtCreateProductStartPostResponse, StartProductProductMgtCreateProductStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/product/product_mgt/create_product/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Products by Domain
 */
export const startProductProductMgtGetProductsByDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProductProductMgtGetProductsByDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProductProductMgtGetProductsByDomainStartPostResponse, StartProductProductMgtGetProductsByDomainStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/product/product_mgt/get_products_by_domain/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Dashboards by Stek
 */
export const startDashboardDashboardMgtGetDashboardsByStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartDashboardDashboardMgtGetDashboardsByStekStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartDashboardDashboardMgtGetDashboardsByStekStartPostResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/dashboard/dashboard_mgt/get_dashboards_by_stek/start',
        ...options
    });
};

/**
 * Start
 * Update a specific dashboard.
 */
export const startDashboardDashboardMgtUpdateDashboardStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDashboardDashboardMgtUpdateDashboardStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartDashboardDashboardMgtUpdateDashboardStartPostResponse, StartDashboardDashboardMgtUpdateDashboardStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/dashboard/dashboard_mgt/update_dashboard/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Delete a Domain
 */
export const startDomainDomainMgtDeleteDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtDeleteDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartDomainDomainMgtDeleteDomainStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/domain_mgt/delete_domain/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Domains by Stek
 */
export const startDomainDomainMgtGetDomainsByStekStartPost = <ThrowOnError extends boolean = false>(options?: Options<StartDomainDomainMgtGetDomainsByStekStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartDomainDomainMgtGetDomainsByStekStartPostResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/domain_mgt/get_domains_by_stek/start',
        ...options
    });
};

/**
 * Start
 * Update a domain.
 */
export const startDomainDomainMgtUpdateDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtUpdateDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartDomainDomainMgtUpdateDomainStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/domain_mgt/update_domain/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Domain
 */
export const startDomainDomainMgtGetDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtGetDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartDomainDomainMgtGetDomainStartPostResponse, StartDomainDomainMgtGetDomainStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/domain_mgt/get_domain/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Create a new Domain
 */
export const startDomainDomainMgtCreateDomainStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainDomainMgtCreateDomainStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartDomainDomainMgtCreateDomainStartPostResponse, StartDomainDomainMgtCreateDomainStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/domain_mgt/create_domain/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update a business entity details and/or definition.
 */
export const startDomainBusinessEntityMgtUpdateBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/business_entity_mgt/update_business_entity/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get a business entity.
 */
export const startDomainBusinessEntityMgtGetBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtGetBusinessEntityStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponse, StartDomainBusinessEntityMgtGetBusinessEntityStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/business_entity_mgt/get_business_entity/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Create a new business entity.
 */
export const startDomainBusinessEntityMgtCreateBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartDomainBusinessEntityMgtCreateBusinessEntityStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/business_entity_mgt/create_business_entity/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Delete a business entity.
 */
export const startDomainBusinessEntityMgtDeleteBusinessEntityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/business_entity_mgt/delete_business_entity/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get a list of business entities belonging to a domain
 */
export const startDomainBusinessEntityMgtGetBusinessEntitiesStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponse, StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/business_entity_mgt/get_business_entities/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get all Role(s) for provided Domain
 */
export const startDomainRoleMgtGetRolesStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtGetRolesStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartDomainRoleMgtGetRolesStartPostResponse, StartDomainRoleMgtGetRolesStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/role_mgt/get_roles/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Create Role in Domain
 */
export const startDomainRoleMgtCreateRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtCreateRoleStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartDomainRoleMgtCreateRoleStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/role_mgt/create_role/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update a Role.
 */
export const startDomainRoleMgtUpdateRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtUpdateRoleStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartDomainRoleMgtUpdateRoleStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/role_mgt/update_role/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Delete Role
 */
export const startDomainRoleMgtDeleteRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtDeleteRoleStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartDomainRoleMgtDeleteRoleStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/role_mgt/delete_role/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Role
 */
export const startDomainRoleMgtGetRoleStartPost = <ThrowOnError extends boolean = false>(options: Options<StartDomainRoleMgtGetRoleStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartDomainRoleMgtGetRoleStartPostResponse, StartDomainRoleMgtGetRoleStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/domain/role_mgt/get_role/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Lane
 */
export const startProcessLaneMgtGetLaneStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLaneStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessLaneMgtGetLaneStartPostResponse, StartProcessLaneMgtGetLaneStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/lane_mgt/get_lane/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Lane by Role Id.
 */
export const startProcessLaneMgtGetLaneByRoleIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLaneByRoleIdStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessLaneMgtGetLaneByRoleIdStartPostResponse, StartProcessLaneMgtGetLaneByRoleIdStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/lane_mgt/get_lane_by_role_id/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Lane by BPMN ID.
 */
export const startProcessLaneMgtGetLaneByBpmnIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLaneByBpmnIdStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessLaneMgtGetLaneByBpmnIdStartPostResponse, StartProcessLaneMgtGetLaneByBpmnIdStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/lane_mgt/get_lane_by_bpmn_id/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Lanes by Process.
 */
export const startProcessLaneMgtGetLanesByProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessLaneMgtGetLanesByProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessLaneMgtGetLanesByProcessStartPostResponse, StartProcessLaneMgtGetLanesByProcessStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/lane_mgt/get_lanes_by_process/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Task
 */
export const startProcessProcessElementMgtGetProcessElementByBpmnIdStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponse, StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/get_process_element_by_bpmn_id/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Delete Gateway
 */
export const startProcessProcessElementMgtDeleteGatewayStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteGatewayStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtDeleteGatewayStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/delete_gateway/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update event.
 */
export const startProcessProcessElementMgtUpdateEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateEventStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtUpdateEventStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/update_event/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Tasks by Process.
 */
export const startProcessProcessElementMgtGetProcessElementsByProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponse, StartProcessProcessElementMgtGetProcessElementsByProcessStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/get_process_elements_by_process/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Generate a React component for a process element.
 */
export const startProcessProcessElementMgtGenerateUserInterfaceStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGenerateUserInterfaceStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponse, StartProcessProcessElementMgtGenerateUserInterfaceStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/generate_user_interface/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update gateway.
 */
export const startProcessProcessElementMgtUpdateGatewayStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateGatewayStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtUpdateGatewayStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/update_gateway/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Event.
 */
export const startProcessProcessElementMgtGetEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetEventStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessElementMgtGetEventStartPostResponse, StartProcessProcessElementMgtGetEventStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/get_event/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Unarchive Process Element.
 */
export const startProcessProcessElementMgtUnarchiveProcessElementStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUnarchiveProcessElementStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtUnarchiveProcessElementStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/unarchive_process_element/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Delete Event
 */
export const startProcessProcessElementMgtDeleteEventStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteEventStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtDeleteEventStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/delete_event/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Archive Task
 */
export const startProcessProcessElementMgtArchiveProcessElementStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtArchiveProcessElementStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtArchiveProcessElementStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/archive_process_element/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Delete Task
 */
export const startProcessProcessElementMgtDeleteTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteTaskStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtDeleteTaskStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/delete_task/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Task.
 */
export const startProcessProcessElementMgtGetTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetTaskStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessElementMgtGetTaskStartPostResponse, StartProcessProcessElementMgtGetTaskStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/get_task/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update flow.
 */
export const startProcessProcessElementMgtUpdateFlowStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateFlowStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtUpdateFlowStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/update_flow/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Gateway.
 */
export const startProcessProcessElementMgtGetGatewayStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetGatewayStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessElementMgtGetGatewayStartPostResponse, StartProcessProcessElementMgtGetGatewayStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/get_gateway/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update task.
 */
export const startProcessProcessElementMgtUpdateTaskStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtUpdateTaskStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtUpdateTaskStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/update_task/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Flow.
 */
export const startProcessProcessElementMgtGetFlowStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtGetFlowStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessElementMgtGetFlowStartPostResponse, StartProcessProcessElementMgtGetFlowStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/get_flow/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Delete Flow
 */
export const startProcessProcessElementMgtDeleteFlowStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessElementMgtDeleteFlowStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessElementMgtDeleteFlowStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_element_mgt/delete_flow/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Process
 */
export const startProcessProcessMgtGetProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtGetProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessMgtGetProcessStartPostResponse, StartProcessProcessMgtGetProcessStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_mgt/get_process/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Move a Process to a new Product.
 */
export const startProcessProcessMgtMoveProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtMoveProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessMgtMoveProcessStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_mgt/move_process/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Generate a Process definition.
 */
export const startProcessProcessMgtGenerateDefinitionStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtGenerateDefinitionStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessMgtGenerateDefinitionStartPostResponse, StartProcessProcessMgtGenerateDefinitionStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_mgt/generate_definition/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Deploy a Process to process engine.
 *
 * Returns:
 * resp (dict): Of the form:
 * {'deployment_id': str}
 */
export const startProcessProcessMgtDeployProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtDeployProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessMgtDeployProcessStartPostResponse, StartProcessProcessMgtDeployProcessStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_mgt/deploy_process/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Update a process.
 */
export const startProcessProcessMgtUpdateProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtUpdateProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessMgtUpdateProcessStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_mgt/update_process/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Delete a Process
 */
export const startProcessProcessMgtDeleteProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtDeleteProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, StartProcessProcessMgtDeleteProcessStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_mgt/delete_process/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Start
 * Create a new Process
 */
export const startProcessProcessMgtCreateProcessStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtCreateProcessStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessMgtCreateProcessStartPostResponse, StartProcessProcessMgtCreateProcessStartPostError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_mgt/create_process/start',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Start
 * Get Processes by Product.
 */
export const startProcessProcessMgtGetProcessesByProductStartPost = <ThrowOnError extends boolean = false>(options: Options<StartProcessProcessMgtGetProcessesByProductStartPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StartProcessProcessMgtGetProcessesByProductStartPostResponse, StartProcessProcessMgtGetProcessesByProductStartPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/process/process_mgt/get_processes_by_product/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Users
 * Get all users.
 */
export const getUsersUserGet = <ThrowOnError extends boolean = false>(options?: Options<GetUsersUserGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUsersUserGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/',
        ...options
    });
};

/**
 * Create User
 * Create a user.
 */
export const createUserUserPost = <ThrowOnError extends boolean = false>(options: Options<CreateUserUserPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CreateUserUserPostResponse, CreateUserUserPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Signup
 * Create a new user account.
 */
export const signupUserSignupPost = <ThrowOnError extends boolean = false>(options: Options<SignupUserSignupPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SignupUserSignupPostResponse, SignupUserSignupPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/signup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete User
 * Delete a User.
 */
export const deleteUserUserUserIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteUserUserUserIdDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<unknown, DeleteUserUserUserIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/{user_id}',
        ...options
    });
};

/**
 * Get Self
 * Get currently logged in user.
 */
export const getSelfUserMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetSelfUserMeGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSelfUserMeGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/me',
        ...options
    });
};

/**
 * Get Domain Roles
 * Get roles for given domain.
 */
export const getDomainRolesUserUserIdDomainRolesGet = <ThrowOnError extends boolean = false>(options: Options<GetDomainRolesUserUserIdDomainRolesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDomainRolesUserUserIdDomainRolesGetResponse, GetDomainRolesUserUserIdDomainRolesGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/{user_id}/domain-roles',
        ...options
    });
};

/**
 * Make User Manager
 * Make user a user manager.
 */
export const makeUserManagerUserUserIdMakeUserManagerPost = <ThrowOnError extends boolean = false>(options: Options<MakeUserManagerUserUserIdMakeUserManagerPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, MakeUserManagerUserUserIdMakeUserManagerPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/{user_id}/make-user-manager',
        ...options
    });
};

/**
 * Make User
 * Make user a regular user (not user manager).
 */
export const makeUserUserUserIdMakeUserPost = <ThrowOnError extends boolean = false>(options: Options<MakeUserUserUserIdMakeUserPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, MakeUserUserUserIdMakeUserPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/{user_id}/make-user',
        ...options
    });
};

/**
 * List Api Keys
 * List all API keys for the current user in the current organization.
 */
export const listApiKeysUserApiKeysGet = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeysUserApiKeysGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListApiKeysUserApiKeysGetResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/api-keys',
        ...options
    });
};

/**
 * Create Api Key
 * Create a new API key for the current user in the current organization.
 */
export const createApiKeyUserApiKeyPost = <ThrowOnError extends boolean = false>(options: Options<CreateApiKeyUserApiKeyPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<CreateApiKeyUserApiKeyPostResponse, CreateApiKeyUserApiKeyPostError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/api-key',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Revoke Api Key
 * Revoke an API key.
 */
export const revokeApiKeyUserApiKeyApiKeyIdDelete = <ThrowOnError extends boolean = false>(options: Options<RevokeApiKeyUserApiKeyApiKeyIdDeleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<RevokeApiKeyUserApiKeyApiKeyIdDeleteResponse, RevokeApiKeyUserApiKeyApiKeyIdDeleteError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/user/api-key/{api_key_id}',
        ...options
    });
};

/**
 * Preview Link
 * Get the metadata from a weblink based on the HTML.
 */
export const previewLinkProxyPreviewLinkGet = <ThrowOnError extends boolean = false>(options: Options<PreviewLinkProxyPreviewLinkGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PreviewLinkProxyPreviewLinkGetResponse, PreviewLinkProxyPreviewLinkGetError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                name: 'organization',
                type: 'apiKey'
            },
            {
                name: 'stek',
                type: 'apiKey'
            }
        ],
        url: '/proxy/preview-link',
        ...options
    });
};